export default __webpack_public_path__ + "static/media/word-thumb-icon.440c9728.svg";